export default "__VITE_ASSET__7cad6489__"